const locale = {
	INVENTURIUS: "Inventurius",
	OVERVIEW: "Übersicht",
	WELCOMEBACK: "Willkommen zurück",
};

export default locale;
